import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/avaliacaofornec",
    name: "AvaliacaoFornec",
    component: () => import("../../AvaliacaoFornec/AvaliacaoFornecView.vue"),
  },
];
